<template>
	<transition
			appear
			:appear-active-class="$_shtLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" no-gutters>
			<v-col>
				<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
					<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
						<v-row :key="contentKey" no-gutters>
							<v-col>
								<template v-if="contentVals.title">
									<v-row justify="center">
										<v-col cols="11" md="9">
											<v-sheet
													class="customVSheet pa-3"
													:color="$_shtLyt_styleHeaderSheetColor"
													:dark="$_shtLyt_styleHeaderSheetDark"
													:elevation="$_shtLyt_styleHeaderSheetElevation"
													:light="$_shtLyt_styleHeaderSheetLight">
												<v-card color="transparent" flat>
													<v-card-text class="center">
														<center>
															<span	class="headline"
																	v-html="$_shtLyt_langContentTitle(contentVals)" />
														</center>
													</v-card-text>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<v-row justify="center">
									<v-col cols="11" md="9">
										<v-sheet
												class="customVSheet"
												:color="$_shtLyt_styleBodySheetColor"
												:dark="$_shtLyt_styleBodySheetDark"
												:elevation="$_shtLyt_styleBodySheetElevation"
												:light="$_shtLyt_styleBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<template v-if="isObject(contentVals.bigImage)">
													<v-row>
														<v-col>
															<v-img	class="customVImg"
																	:src="$_shtLyt_styleContentBigImageUrl(contentVals)" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(contentVals.video)">
													<v-row>
														<v-col>
															<card-video
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(contentVals.bigChart)">
													<v-row>
														<v-col>
															<card-big-chart
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<v-row>
													<template v-if="isObject(contentVals.image)">
														<v-col cols="12" md="4" class="center">
															<v-img	class="customVImg"
																	:src="$_shtLyt_styleContentImageUrl(contentVals)" />
														</v-col>
													</template>
													<v-col>
														<v-row no-gutters>
															<v-col>
																<template v-if="contentVals.subTitle">
																	<v-card-title>
																		<span v-html="$_shtLyt_langContentSubTitle(contentVals)" />
																	</v-card-title>
																</template>
																<template v-if="!isFalse($_shtLyt_langContentText(contentVals))">
																	<v-card-text>
																		<span	class="markdown"
																				v-html="marked($_shtLyt_langContentText(contentVals))" />
																	</v-card-text>
																</template>
																<template v-if="contentVals.actionButtons">
																	<v-card-actions>
																		<v-row dense justify="center">
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																				<v-col :key="actionButtonKey" cols="auto">
																					<v-btn	class="customVBtn"
																							:block="$_shtLyt_styleActionButtonBlock"
																							:color="$_shtLyt_styleActionButtonColor"
																							:dark="$_shtLyt_styleActionButtonDark"
																							:depressed="$_shtLyt_styleActionButtonDepressed"
																							:elevation="$_shtLyt_styleActionButtonElevation"
																							:large="$_shtLyt_styleActionButtonLarge"
																							:light="$_shtLyt_styleActionButtonLight"
																							:outlined="$_shtLyt_styleActionButtonOutlined"
																							:rounded="$_shtLyt_styleActionButtonRounded"
																							:small="$_shtLyt_styleActionButtonSmall"
																							:text="$_shtLyt_styleActionButtonFlat"
																							@click="openLink(actionButtonVals.link)"
																							v-text="$_shtLyt_langActionButtonTitle(actionButtonVals)" />
																				</v-col>
																			</template>
																		</v-row>
																	</v-card-actions>
																</template>
															</v-col>
														</v-row>
													</v-col>
													<template v-if="isObject(contentVals.chart)">
														<v-col cols="12" md="6" class="center">
															<card-chart
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</template>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'SheetLayout',
		props: {
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			// (content)
			$_shtLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_shtLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_shtLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_shtLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_shtLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_shtLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_shtLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_shtLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_shtLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_shtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_shtLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_shtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_shtLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_shtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_shtLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_shtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.light)
			},
			$_shtLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_shtLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_shtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_shtLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_shtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_shtLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_shtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_shtLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_shtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_shtLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_shtLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_shtLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_shtLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_shtLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_shtLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_shtLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_shtLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_shtLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_shtLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_shtLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_shtLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_shtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_shtLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_shtLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_shtLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_shtLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_shtLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_shtLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		}
	}
</script>

<style scoped>
</style>
